
const Error = () => {
    return (
        <p style={{color:'red'}}>Your session has expired. Please login again in portal.</p>
    );    
}

export default Error;